import { render, staticRenderFns } from "./TestSmsMessage.vue?vue&type=template&id=0707ce34"
import script from "./TestSmsMessage.vue?vue&type=script&lang=js"
export * from "./TestSmsMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports